/**
 * Every Gateway path the Notification Templates module calls.
 *
 * The notification service hosts both gateway and template configuration under
 * `/v1/notifications`; templates live at `/v1/notifications/templates`.
 */
export const notificationTemplateEndpoints = {
  list: '/v1/notifications/templates',
  create: '/v1/notifications/templates',
  detail: (templateId: string) => `/v1/notifications/templates/${templateId}`,
  update: (templateId: string) => `/v1/notifications/templates/${templateId}`,
  delete: (templateId: string) => `/v1/notifications/templates/${templateId}`,
  tags: '/v1/notifications/templates/tags',
} as const;
